import styled from '@emotion/styled';
import { Box, themeVars, Text } from '@eds-web/react';
import { BaseContent } from './Content.styled';
import React from 'react';
import { device } from '../../constants/breakpoint';

export const CompetitiveContent = styled(BaseContent)`
    padding: 32px 0 64px 0;
    min-height: 70vh;
    display: flex;
    flex-direction: column;
    gap: 64px;
    box-sizing: border-box;

    @media screen and ${device.laptop} {
        padding: 16px 20px 32px 20px;
        gap: 48px;
        max-width: 100%;
    }

    @media screen and ${device.mobile} {
        padding: 16px 20px 32px 20px;
        gap: 32px;
    }
`;

export const StyledCompetitiveHeader = styled(Box)`
    gap: 8px;
    display: flex;
    flex-direction: column;
    color: ${themeVars.color.transparent.light['065']};
    a {
        color: ${themeVars.color.palette.blue['500']};
    }

    @media screen and ${device.mobile} {
        gap: 4px;
    }
`;

export const StyledCompetitiveAccount = styled(Text as React.ComponentType<any>)`
    font-weight: 600;

    @media screen and ${device.mobile} {
        font-size: 14px;
    }
`;
